import React from "react";

/**
 * Símbolo "MP" da Mallu Pay, recortado do logo oficial (fundo transparente).
 * O símbolo é horizontal (~1,76:1): o tamanho é controlado pela altura e a
 * largura acompanha. O logo completo (símbolo + "Mallu Pay") fica em
 * /img/mallupay/mallu-logo.webp, para fundos claros.
 */
export const MALLU_MARK_SRC = "/img/mallupay/mallu-mark.webp";
export const MALLU_LOGO_SRC = "/img/mallupay/mallu-logo.webp";

const cx = (...parts) => parts.filter(Boolean).join(" ");

export const MalluMark = ({ size, className, style, alt = "", eager = false }) => (
  <img
    src={MALLU_MARK_SRC}
    alt={alt}
    aria-hidden={alt ? undefined : "true"}
    className={cx("pp-lockup-mark", className)}
    style={size == null ? style : { height: size, width: "auto", ...style }}
    width="600"
    height="341"
    loading={eager ? "eager" : "lazy"}
    decoding="async"
  />
);

/** Lockup horizontal: símbolo + "Mallu Pay" ("Pay" em rosa, como no logo). */
export const MalluLockup = ({ className, style, label = "Mallu Pay", eager = false }) => (
  <span role="img" aria-label={label} className={cx("pp-lockup", className)} style={style}>
    <MalluMark eager={eager} />
    <span className="pp-lockup-word" aria-hidden="true">
      Mallu <em>Pay</em>
    </span>
  </span>
);
